exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".checkbox-filter .checkbox-filter-body button{margin-top:15px}.checkbox-filter .checkbox-list{list-style:none;padding-left:0}.checkbox-filter .checkbox-list .checkbox-item span{min-width:0;display:inline-block;overflow-wrap:break-word;word-wrap:break-word}.checkbox-filter-accordion.is-open .checkbox-filter-selections{display:none}.checkbox-filter-accordion.is-closed .checkbox-filter-selections{display:block;font-size:1.2rem;max-width:160px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/shared/components/facets/checkbox-filter/checkbox-filter.scss
// module id = 5249
// module chunks = 0